// Keep track of the action that is happening to a member or membership at a given time and ensure that they can only be
// in a single state at a given time.
const CurrentRedemptionAction = Object.freeze({
    REDEEMING: 'redeeming',
    UNREDEEMING: 'unredeeming',
    NONE: 'none',
});

module.exports = CurrentRedemptionAction;
